import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, AfterContentInit, AfterViewInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FikoYTService } from '@/src/service/fikoyt.service';
import * as THREE from 'three';
import { Fiko3DYaziIsaretleyici } from '../Fiko3DYaziIsaretleyici';

declare var $: any;

@Component({
  selector: 'fikoyt-3dyazi-isaretleyici',
  templateUrl: './fiko-3dyazi-isaretleyici.component.html',
  styleUrls: ['./fiko-3dyazi-isaretleyici.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class Fiko3dYaziIsaretleyiciComponent implements OnInit, AfterContentInit, AfterViewInit, OnDestroy {
  id_dialog = this.FikoYT.fikoIdUret();
  private modalBaslatildi = false;
  subsList: Subscription[] = [];

  @Input() isaretleyici: Fiko3DYaziIsaretleyici; // Dialog Core için @Input
  @Input() pencere: any; // Dialog Core'dan gelen pencere referansı

  // Geriye uyumluluk için
  get nesne() { return this.isaretleyici; }
  set nesne(val: Fiko3DYaziIsaretleyici) { this.isaretleyici = val; }

  constructor(public readonly FikoYT: FikoYTService, public readonly CD: ChangeDetectorRef) {
    this.subsList.push(FikoYT.degisti.subscribe(() => {
      this.CD.detectChanges();
    }))
  }

  ngOnInit(): void {
    // Force change detection
    setTimeout(() => {
      this.CD.detectChanges();
    }, 0);

    // Eğer isaretleyici gelmediyse, Dialog Core'dan gelen tüm verileri kontrol et
    if (!this.isaretleyici) {
      return;
    }
  }

  ngAfterContentInit(): void {
    // Hala isaretleyici yoksa Dialog Core'dan gelen verileri farklı yolla bulmayı dene
    if (!this.isaretleyici) {
      return;
    }

    // Fomantic UI checkbox'ları initialize et
    setTimeout(() => {
      $(`#sabitBoyut_${this.id_dialog}`).checkbox({
        onChecked: () => {
          if (this.isaretleyici) {
            this.setSabitBoyut(true);
            this.CD.detectChanges();
          }
        },
        onUnchecked: () => {
          if (this.isaretleyici) {
            this.setSabitBoyut(false);
            this.CD.detectChanges();
          }
        }
      });

      $(`#sabitYon_${this.id_dialog}`).checkbox({
        onChecked: () => {
          if (this.isaretleyici) {
            this.setSabitYon(true);
            this.CD.detectChanges();
          }
        },
        onUnchecked: () => {
          if (this.isaretleyici) {
            this.setSabitYon(false);
            this.CD.detectChanges();
          }
        }
      });
    }, 100);
  }

  ngAfterViewInit(): void {
    // AfterViewInit'te checkbox'ları güncelle
    if (this.isaretleyici) {
      setTimeout(() => {
        $(`#sabitBoyut_${this.id_dialog}`).checkbox(this.getSabitBoyut() ? 'set checked' : 'set unchecked');
        $(`#sabitYon_${this.id_dialog}`).checkbox(this.getSabitYon() ? 'set checked' : 'set unchecked');
      }, 150);
    }
  }

  renkDegisti($event: any) {
    if (this.isaretleyici) {
      if (this.isaretleyici.yaziTipi === '3D') {
        const yazi3d = this.isaretleyici.yazi3d as any; // Type assertion
        yazi3d.renk = new THREE.Color($event);
      } else {
        // Sprite için renk değiştirme
        const sprite = this.isaretleyici.yazi3d as THREE.Sprite;
        if (sprite && sprite.material) {
          const material = sprite.material as THREE.SpriteMaterial;
          material.color = new THREE.Color($event);
          material.needsUpdate = true;
        }
      }

      // Kontrol ve kamera update'leri
      if (this.isaretleyici.sahne.anaGosterim.aktifKontrol) {
        this.isaretleyici.sahne.anaGosterim.aktifKontrol.update();
      }

      // Kamera projection matrix update
      if (this.isaretleyici.sahne.anaGosterim.aktifKamera) {
        this.isaretleyici.sahne.anaGosterim.aktifKamera.updateProjectionMatrix();
      }

      // Three.js render'ı tetikle
      this.isaretleyici.sahne.anaGosterim.ciz();
    }
  }

  // Template helper metodları
  getYazi(): string {
    return this.isaretleyici?.getYazi() || '';
  }

  setYazi(text: string): void {
    if (this.isaretleyici) {
      this.isaretleyici.setYazi(text);
      this.yaziDegisti();
    }
  }

  getRenk(): string {
    if (!this.isaretleyici) return '#ffff00';

    if (this.isaretleyici.yaziTipi === '3D') {
      const yazi3d = this.isaretleyici.yazi3d as any;
      return '#' + yazi3d.renk?.getHexString() || '#ffff00';
    }
    return '#ffff00'; // Default renk
  }

  getBoyut(): number {
    if (this.isaretleyici.yaziTipi === '3D') {
      const yazi3d = this.isaretleyici.yazi3d as any;
      return yazi3d.boyut || 0.3;
    }
    return 0.3; // Default boyut
  }

  setBoyut(boyut: number): void {
    if (this.isaretleyici) {
      if (this.isaretleyici.yaziTipi === '3D') {
        const yazi3d = this.isaretleyici.yazi3d as any;
        yazi3d.boyut = boyut;
      } else {
        // Sprite için boyut değiştirme
        const sprite = this.isaretleyici.yazi3d as THREE.Sprite;
        if (sprite) {
          sprite.scale.set(boyut, boyut, 1);
        }
      }
      this.boyutDegisti();
    }
  }

  getSabitBoyut(): boolean {
    if (this.isaretleyici.yaziTipi === '3D') {
      const yazi3d = this.isaretleyici.yazi3d as any;
      return yazi3d.sabitBoyut || false;
    } else {
      // Sprite için sabit boyut özelliği
      return this.isaretleyici.sabitBoyut;
    }
    return false;
  }

  setSabitBoyut(deger: boolean): void {
    if (this.isaretleyici) {
      if (this.isaretleyici.yaziTipi === '3D') {
        const yazi3d = this.isaretleyici.yazi3d as any;
        yazi3d.sabitBoyut = deger;
      } else {
        // Sprite için sabit boyut özelliği
        this.isaretleyici.sabitBoyut = deger;
        // Sprite'ı yeniden oluşturarak sabit boyutu uygula
        this.isaretleyici.setYazi(this.getYazi());
      }
      // Three.js render'ı tetikle
      this.isaretleyici.sahne.anaGosterim.ciz();
      this.FikoYT.degisti.emit();
    }
  }

  getSabitYon(): boolean {
    if (this.isaretleyici.yaziTipi === '3D') {
      const yazi3d = this.isaretleyici.yazi3d as any;
      return yazi3d.sabitYon || false;
    }
    return false;
  }

  setSabitYon(deger: boolean): void {
    if (this.isaretleyici) {
      if (this.isaretleyici.yaziTipi === '3D') {
        const yazi3d = this.isaretleyici.yazi3d as any;
        yazi3d.sabitYon = deger;
      }
      // Three.js render'ı tetikle
      this.isaretleyici.sahne.anaGosterim.ciz();
      this.FikoYT.degisti.emit();
    }
  }

  yaziDegisti() {
    if (this.isaretleyici) {
      // Yazı değiştiğinde merkezi güncelle
      this.isaretleyici.merkezle();

      // Sprite'ın visible olduğunu kontrol et
      if (this.isaretleyici.yazi3d) {
        this.isaretleyici.yazi3d.visible = this.isaretleyici.visible;
      }

      // Kontrol ve kamera update'leri
      if (this.isaretleyici.sahne.anaGosterim.aktifKontrol) {
        this.isaretleyici.sahne.anaGosterim.aktifKontrol.update();
      }

      // Kamera projection matrix update
      if (this.isaretleyici.sahne.anaGosterim.aktifKamera) {
        this.isaretleyici.sahne.anaGosterim.aktifKamera.updateProjectionMatrix();
      }

      // Three.js render'ı tetikle
      this.isaretleyici.sahne.anaGosterim.ciz();
      this.FikoYT.degisti.emit();
    }
  }

  boyutDegisti() {
    if (this.isaretleyici) {
      // Boyut değiştiğinde merkezi güncelle
      this.isaretleyici.merkezle();

      // Kontrol ve kamera update'leri
      if (this.isaretleyici.sahne.anaGosterim.aktifKontrol) {
        this.isaretleyici.sahne.anaGosterim.aktifKontrol.update();
      }

      // Kamera projection matrix update
      if (this.isaretleyici.sahne.anaGosterim.aktifKamera) {
        this.isaretleyici.sahne.anaGosterim.aktifKamera.updateProjectionMatrix();
      }

      this.isaretleyici.sahne.anaGosterim.ciz();
      this.FikoYT.degisti.emit();
    }
  }

  // Eski modal sistemi için (geriye uyumluluk)
  public ac(nesne?: Fiko3DYaziIsaretleyici) {
    var _this = this;
    this.isaretleyici = nesne;

    if (!this.modalBaslatildi) {
      $("#dialogFiko3DYaziIsaretleyici" + this.id_dialog).modal({
        closable: false, allowMultiple: true, detachable: false, keyboardShortcuts: false,
        onShow: function () {
          $("#dialogFiko3DYaziIsaretleyici" + _this.id_dialog).parent().removeClass('dimmer');
          $("#dialogFiko3DYaziIsaretleyici" + _this.id_dialog).draggable({ handle: ".baslikMove" });
        }
      });
      this.modalBaslatildi = true;
    }
    $('.ui.checkbox').checkbox();
    $("#dialogFiko3DYaziIsaretleyici" + this.id_dialog).modal('show');
    this.CD.detectChanges();
  }

  public kapa() {
    // Dialog core'ın kapa metodunu çağır
    // FikoDialogCore'dan { instance: this } şeklinde gelir
    if (this.pencere?.instance && typeof this.pencere.instance.kapa === 'function') {
      try {
        this.pencere.instance.kapa();
        return;
      } catch (error) {
      }
    }

    // Fallback: direkt pencere.kapa() dene (eski pattern için)
    if (this.pencere && typeof this.pencere.kapa === 'function') {
      try {
        this.pencere.kapa();
        return;
      } catch (error) {
      }
    }
  }

  ngOnDestroy(): void {
    $("#dialogFiko3DYaziIsaretleyici" + this.id_dialog).remove();
    this.subsList.forEach(element => {
      element.unsubscribe();
    });
  }
}
